import api from './api';

const AuthService = {
  login: async (email, password) => {
    try {
      const response = await api.post('/usuarios/login', { email, password });
      
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('usuario', JSON.stringify(response.data.usuario));
        console.log('✅ Token guardado correctamente');
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Error en login:', error.response?.data || error.message);
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    console.log('✅ Sesión cerrada');
  },

  getToken: () => localStorage.getItem('token'),

  getUsuario: () => {
    const usuario = localStorage.getItem('usuario');
    return usuario ? JSON.parse(usuario) : null;
  },

  isAutenticado: () => !!localStorage.getItem('token')
};

export default AuthService;